// extracted by mini-css-extract-plugin
export default {"navigationCategoryContainer":"navigation-category-skeleton-module--navigation-category-container--9786e"};